import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { CoreDropdownSelect, SelectValueAccessor } from "@svs/angular";

@Component({
  selector: "app-settings-modal-font-size-selection",
  imports: [
    CoreDropdownSelect,
    SelectValueAccessor,
    ReactiveFormsModule,
  ],
  templateUrl: "./settings-modal-font-size-selection.component.html",
  styleUrl: "./settings-modal-font-size-selection.component.scss",
})
export class SettingsModalFontSizeSelectionComponent {
  @Input({ required: true }) form: FormGroup;

  options = [
    { text: "Standard", value: "md" },
    { text: "Groß", value: "lg" },
    { text: "Extragroß", value: "xl" },
  ];

  get control() {
    return this.form.get("textSize") as FormControl;
  }

  selector = (o) => o?.text;
  comparator = (selected, option) => selected?.value === option?.value;
}
